import { Timestamp as Ts } from '@bufbuild/protobuf';
/** `COMPANY:{id}` | `GOVERNMENT_ORG:{id}` as it sits in the URL. */ export function parseOrg(value) {
    const at = value?.indexOf(':') ?? -1;
    if (!value || at < 0) return undefined;
    const kind = value.slice(0, at);
    const id = value.slice(at + 1);
    return (kind === 'COMPANY' || kind === 'GOVERNMENT_ORG') && id ? {
        kind,
        id
    } : undefined;
}
export const orgParam = (o)=>`${o.kind}:${o.id}`;
export const yearOf = (ts)=>ts ? ts.toDate().getUTCFullYear() : undefined;
export const currentYear = ()=>new Date().getUTCFullYear();
/**
 * The `as_of` the chart asks for: Dec 31 of a past year. The current year
 * leaves it unset (today), so the chart never shows a date in the future.
 */ export function asOfTimestamp(year) {
    return year >= currentYear() ? undefined : Ts.fromDate(new Date(Date.UTC(year, 11, 31)));
}
/** The holder in the seat at the end of `year` (the latest start wins), if any. */ export function holderAt(seat, year) {
    const held = seat.holders.filter((h)=>{
        const start = yearOf(h.startDate);
        const end = yearOf(h.endDate);
        return (start === undefined || start <= year) && (end === undefined || end > year);
    });
    return held[held.length - 1];
}
export function lastHolderBefore(seat, year) {
    const gone = seat.holders.filter((h)=>{
        const end = yearOf(h.endDate);
        return end !== undefined && end <= year;
    });
    return gone[gone.length - 1];
}
/** Seats exist from `created_on` until `retired_on`; an unset creation date means "always". */ export function seatExistsAt(seat, year) {
    const created = yearOf(seat.createdOn);
    const retired = yearOf(seat.retiredOn);
    return (created === undefined || created <= year) && (retired === undefined || retired > year);
}
/** Seats have no stored title: the label is a holder's job title. Never blank. */ export const SEAT_FALLBACK_LABEL = 'Open seat';
export function seatLabel(seat) {
    if (seat.title) return seat.title;
    const titled = [
        ...seat.holders
    ].reverse().find((h)=>h.title);
    return titled?.title ?? SEAT_FALLBACK_LABEL;
}
/** First holder start year (or this year) up to the current year, for the "As of" picker. */ export function yearRange(seats) {
    const now = currentYear();
    const starts = seats.flatMap((s)=>s.holders.map((h)=>yearOf(h.startDate) ?? now));
    const min = Math.min(now, ...starts);
    return Array.from({
        length: now - min + 1
    }, (_, i)=>min + i);
}
export const refName = (ref)=>ref?.name || '';
